<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Checker
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs" 
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('all')}"
                    
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('filter')}"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
        v-if="searchCategory != 'daily_closing_date'"
      >
      </v-text-field>
      <v-menu
        ref="menuPickDate"
        v-model="menuPickDate"
        :close-on-content-click="false"
        :return-value.sync="search"
        transition="scale-transition"
        offset-y
        min-width="auto"
        v-if="searchCategory == 'daily_closing_date'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="search"
            label="Picker in menu"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            class="ma-2"
          single-line
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="search"
          no-title
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menuPickDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menuPickDate.save(search)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>



        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}"
    > -->
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >

    <template v-slot:[`header.checker_type`]="{ header }">
      <v-select
        style=" font-size:10px;"
        :items="optionType"
        :label="header.text"
        v-model="valueType"
        @change="getList"
        item-text="text"
        item-value="value"
              
        class="ma-2"
        hide-details
      >
      </v-select>
    </template>

    <template v-slot:[`item.detail`]="{ item }">
        

          <router-link :to="{name: 'Detail Checker', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link>
    </template>

    <template v-slot:[`item.vehicle_plate_no`]="{ item }">
    
      {{ item.checker_vehicle.vehicle_plate_no }}
      
         
    </template>

    <template v-slot:[`item.checker_bbm`]="{ item }">
      <span v-if="item.checker_bbm==0">Penuh</span>
      <span v-if="item.checker_bbm==1">0</span>
      <span v-if="item.checker_bbm==2">0.5</span>
      <span v-if="item.checker_bbm==3">1</span>
      <span v-if="item.checker_bbm==4">1.5</span>
      <span v-if="item.checker_bbm==5">2</span>
      <span v-if="item.checker_bbm==6">2.5</span>
      <span v-if="item.checker_bbm==7">3</span>
      <span v-if="item.checker_bbm==8">3.5</span>
      <span v-if="item.checker_bbm==9">4</span>
      <span v-if="item.checker_bbm==10">4.5</span>
      <span v-if="item.checker_bbm==11">5</span>
      <span v-if="item.checker_bbm==12">5.5</span>
      <span v-if="item.checker_bbm==13">6</span>
      <span v-if="item.checker_bbm==14">6.5</span>
      <span v-if="item.checker_bbm==15">7</span>
      <span v-if="item.checker_bbm==16">7.5</span>
      <span v-if="item.checker_bbm==17">8</span>
    </template>
    <template v-slot:[`item.checker_type`]="{ item }">
    
      <span v-if="item.checker_type==0">Enter</span>
      <span v-if="item.checker_type==1">Exit</span>
      
         
    </template>

    <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailChecker(item.id)">
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.update"
                      @click="editChecker(item.id)"
                    >
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.delete"
                      @click="deleteConfirmation(item.id)"
                    >
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
    
    
    
    </v-data-table>
    
  </v-card>
    </template>
  
  </resizable-page>
  
  
  </v-app>
  <modal ref="modalDetailPage">
    <template v-slot:body >
      <detail-checker :data_id="$refs.modalDetailPage.data" />
    </template>
  </modal>
  <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD CHECKER</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-checker />
      </template>
    </modal>

    <modal ref="modalEditPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>EDIT CHECKER</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEdit()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <edit-checker  :data_id="$refs.modalEditPage.data"/>
      </template>
    </modal>
</div>
</template>


<script>
import vuetify from '@/plugins/vuetify'
import JsonExcel from "vue-json-excel";
import AddChecker from "@/pages/Dashboard/Workshop/Checker/AddCPage.vue";
import EditChecker from "@/pages/Dashboard/Workshop/Checker/EditCPage.vue";
import DetailChecker from "@/pages/Dashboard/Workshop/Checker/DetailCPage.vue";
import { Modal } from "@/components";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "add-checker": AddChecker, "edit-checker": EditChecker, "detail-checker": DetailChecker
  },
    vuetify,
    data () {
      return {
        mounted:true,
       dialog: false,
        searchValue:null,
        searchCategory:null,
        option_filter: [ 
          // { text: 'Checker Type', value: 'checker_type'},
          { text: 'Plate No', value: 'vehicle_plate_no' },
          // { text: 'KM', value: 'checker_km' },
          // { text: 'BBM', value: 'checker_bbm' },
          // { text: 'RIT', value: 'checker_rit' },
          // { text: 'Drop', value: 'checker_drop' },
          ],
        page: 1,
        valueType : '',
        optionType:[ 
          { text: 'All', value: '' },
          { text: 'Exit', value: '1'},
          { text: 'Enter', value: '0'}],
        totalDataTable: 0,
        numberOfPages: 0,
        loadTable: false,
        role: "",
        search: '',
        options: {},
        headers: [
          // {
          //   text: 'Detail',
          //   align: 'start center',
          //   value: 'detail',
          //   sortable: false
          // },
          {
            text: 'Actions',
            align: 'start center',
            value: 'actions',
            sortable: false
          },
          { text: 'Checker Date', value: 'checker_date'},
          { text: 'Checker Type', value: 'checker_type', sortable : false},
          { text: 'Plate No', value: 'vehicle_plate_no' },
          { text: 'KM', value: 'checker_km' },
          { text: 'BBM', value: 'checker_bbm' },
          { text: 'RIT', value: 'checker_rit' },
          { text: 'Drop', value: 'checker_drop' },
          { text: 'Created At', value: 'created_at', width:'200' },

        ],
        table: [],
        worksheetName: "Checkers",
        fileName:"Checkers.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        exportAll:[],
        field_export: {
              no: 'no',
              checker_type : 'checker_type',
              checker_bbm : 'checker_bbm',
              checker_km : 'checker_km',
              checker_rit : 'checker_rit',
              checker_drop : 'checker_drop',
              checker_kunci : 'checker_kunci',
              checker_putaran_mesin : 'checker_putaran_mesin',
              checker_rem_tangan : 'checker_rem_tangan', 
              checker_pedal : 'checker_pedal',
              checker_posisi_stir_dan_klakson :'checker_posisi_stir_dan_klakson',
              // checker_kartu_oli_dan_maintenance : 'checker_kartu_oli_dan_maintenance',
              checker_wiper_depan_belakang : 'checker_wiper_depan_belakang',
              checker_lampu_sign : 'checker_lampu_sign',
              checker_lampu_baca : 'checker_lampu_baca',
              checker_lampu_utama_depan : 'checker_lampu_utama_depan',
              checker_lampu_rem : 'checker_lampu_rem',
              checker_lampu_mundur : 'checker_lampu_mundur',
              checker_power_window : 'checker_power_window',
              checker_central_lock : 'checker_central_lock',
              checker_elektrik_mirror : 'checker_elektrik_mirror',
              checker_ac :'checker_ac',
              checker_stnk : 'checker_stnk',
              // checker_lighter : 'checker_lighter',
              checker_safety_belt : 'checker_safety_belt',
              checker_head_rest : 'checker_head_rest',
              checker_head_unit : 'checker_head_unit',
              checker_remote_head_unit : 'checker_remote_head_unit',
              checker_mccs : 'checker_mccs',
              checker_sarung_jok : 'checker_sarung_jok',
              checker_karpet_dasar : 'checker_karpet_dasar',
              checker_karpet_karet : 'checker_karpet_karet',
              // checker_asbak_depan_belakang : 'checker_asbak_depan_belakang',
              checker_speedometer : 'checker_speedometer',
              checker_cat_kap_mesin : 'checker_cat_kap_mesin',
              checker_cat_bumper_spakboard : 'checker_cat_bumper_spakboard',
              checker_cat_pintu : 'checker_cat_pintu',
              checker_mika_lampu : 'checker_mika_lampu',
              checker_ban : 'checker_ban',
              checker_velg : 'checker_velg',
              checker_dop_roda : 'checker_dop_roda',
              checker_kembang_ban : 'checker_kembang_ban',
              checker_kaca_film : 'checker_kaca_film',
              checker_kunci_pintu : 'checker_kunci_pintu',
              checker_emblem_sticker : 'checker_emblem_sticker',
              checker_ban_cadangan : 'checker_ban_cadangan',
              checker_oli_mesin : 'checker_oli_mesin',
              checker_air_dan_tutup_radiator : 'checker_air_dan_tutup_radiator',
              checker_accu : 'checker_accu',
              checker_tali_kipas : 'checker_tali_kipas',
              checker_dongkrak : 'checker_dongkrak',
              checker_ban_serep_dan_kunci_roda : 'checker_ban_serep_dan_kunci_roda',
              checker_segitiga_pengaman : 'checker_segitiga_pengaman',
              checker_karpet_bagasi : 'checker_karpet_bagasi',
              checker_p3k : 'checker_p3k',
              checker_berbau : 'checker_berbau',
              checker_goresan : 'checker_goresan',
              checker_mahkota : 'checker_mahkota',
              checker_argometer : 'checker_argometer',
              checker_lampu_bahaya : 'checker_lampu_bahaya',
              checker_sticker_atribut_taksi : 'checker_sticker_atribut_taksi',
              checker_lampu_vacant : 'checker_lampu_vacant',
              created_at: 'created_at',
              updated_at: 'updated_at',
              
          
        },
      }
    },
    watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      
    this.getList();
    this.mounted = false
    },
     methods: {

       formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
       // ambil data yang dibutuhkan

       
    async getList() {
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}

      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

      if(this.valueType!=''){
        if(query.filter){
          Object.assign(query.filter, {checker_type:this.valueType});
        }
        else{
          query.filter = {checker_type:this.valueType}
        }
      }

      
    
      await this.$store.dispatch("workshop_checker/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_checker/list"];
        var pageMeta  = await this.$store.getters["workshop_checker/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta)
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },
    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },

  

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    // //fungsi untuk pinda ke page tambah
    // addData() {
    //   // panggil page add data
    //   this.$router.push({ name: "Add Checker" });
    // },

    addData() {
      this.$refs.modalAddPage.openModal();
    },
    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    detailChecker(id) {
      this.$refs.modalDetailPage.openModal({ id: id });
    },

      modalCloseDetail() {
        this.$refs.modalDetailPage.closeModal();
        this.getList();
      },
    editChecker(id) {
      this.$refs.modalEditPage.openModal({ id: id });
    },

    modalCloseEdit() {
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.deleteChecker(id)
        }
      });
    },
    
    // fungsi delete data
    async deleteChecker(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("workshop_checker/destroy", id)
        //panggil alert succes
        await this.$store.dispatch("alerts/success", "User data delete successfully.")
        //kembali ke page list
        // this.$router.replace({ name: 'List Checker'})
        this.getList();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }
    },


    async dataExportBefore(type){
      if(this.table.length!=0){
        
     
        if(type=="all"){
          await this.$store.dispatch("workshop_checker/list");
          return this.dataExport(await this.$store.getters["workshop_checker/list"]);
        }
        else if(type=="filter"){

          var query = {}

            // if(sortBy.length!=0){
            //   var  sort=sortBy[0]
            //   if(sortDesc[0]){
            //     sort="-"+sortBy[0]
            //   }
            //   query.sort = sort
            // }

            if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

            if(this.valueType!=''){
              if(query.filter){
                Object.assign(query.filter, {checker_type:this.valueType});
              }
              else{
                query.filter = {checker_type:this.valueType}
              }
            }

            
          
            await this.$store.dispatch("workshop_checker/list",query);
             return this.dataExport(await this.$store.getters["workshop_checker/list"]);
        }
      }
      
    },
    
    dataExport(data){
       return data.map((v,index) => ({...v, no: index+1}))
      
     
      }
      // export_type(type,item){
        
      // }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>